// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__JqwRc","small":"switch_small__jlM7r","large":"switch_large__zfQe2","item":"switch_item__kyQ5t","active":"switch_active__dmKxZ"};